import React from "react";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
import {
  BookUserIcon,
  MapPinHouseIcon,
  ShoppingCart,
  UserRound,
} from "lucide-react";
import { Heart } from "lucide-react";
import { ShoppingBag } from "lucide-react";
import { History } from "lucide-react";
import { MapPinHouse } from "lucide-react";
import { UserRoundPen } from "lucide-react";
import { Car } from "lucide-react";
// import { LogOut } from 'lucide-react';
import Footer from "../homePage/components/footer/Footer";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
} from "@chakra-ui/react";
import Wishlist from "./components/Wishlist";
import Orders from "./components/Orders";
import MyAccount from "./components/MyAccount";
import { Link } from "react-router-dom";
export default function AccountDashboard() {
  return (
    <div className="">
      <div className="w-full md:pl-4 md:mt-0 lg:py-[10px] md:py-[20px] py-[5px]">
        <h1 className="text-center lg:text-[40px]  lg:mt-0 md:mt-0 mt-[-17px]  md:text-4xl text-[36px] font-bold text-blue-900 mb-2">
          Dashboard
        </h1>
        <hr className="heading-seperator border-4 border-blue-900" />

        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link to="/account/wishlist">
            <div className="flex items-center justify-center bg-[#cae1d8] text-[#1f4956] rounded border  hover:shadow-inherit h-[70px]  lg:h-[95px] md:h-[90px]  text-2xl hover:font-semibold shadow transition-all duration-300 ease-in-out hover:scale-105    ">
              <Heart size={"29px"} className="me-1" />
              Wishlist
            </div>
          </Link>

          <Link to="/account/orders">
            <div className="flex items-center justify-center bg-[#edc6bf] text-[#a33230] rounded border border-gray-900 h-[70px]  lg:h-[95px] md:h-[90px] text-2xl hover:font-semibold shadow transition-all duration-300 ease-in-out hover:scale-105 hover:border-[#62e4b2] ">
              <ShoppingCart size={"29px"} className="me-1" />
              Orders
            </div>
          </Link>
          <Link to="/account/edit-address">
            <div className="flex items-center justify-center bg-[#c7e9ff] text-[ #25618a] rounded border border-gray-90  h-[70px] lg:h-[95px] md:h-[90px] text-2xl shadow  hover:font-semibold transition-all duration-300 ease-in-out hover:scale-105 hover:border-[#62e4b2] ">
              <MapPinHouseIcon size={"29px"} className="me-1" />
              Addresses
            </div>
          </Link>
          <Link to="/account/edit-account">
            <div className="flex items-center justify-center bg-[#f7cbb7] text-[#d66540] rounded border border-gray-90  h-[70px] lg:h-[95px] md:h-[90px]  text-2xl shadow hover:font-semibold transition-all duration-300 ease-in-out hover:scale-105 hover:border-[#62e4b2] ">
              <BookUserIcon size={"29px"} className="me-1" />
              Account Details
            </div>
          </Link>
          {/* <div className='flex items-center justify-center bg-[#c2c4e7] text-[#2c3264] rounded border border-gray-900 h-[50px] lg:h-[100px] text-xl shadow'>
                        Log out
                    </div> */}
        </div>
      </div>
    </div>
  );
}
